import { removeTrailingSlash } from '../utilities/utilities.url';
export async function getStreamObject(npoplayer, payload) {
    try {
        const controller = new AbortController();
        const { signal } = controller;
        const timeout = setTimeout(() => {
            controller.abort();
        }, 5000);
        const response = await fetch(removeTrailingSlash(payload.baseURL) + '/stream-link', {
            method: 'post',
            headers: {
                'Accept': '*/*',
                'Authorization': payload.jwt,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload.data),
            signal
        });
        clearTimeout(timeout);
        const streamApiResponse = await response.json();
        if (response.ok) {
            return streamApiResponse;
        }
        else {
            npoplayer.doError(`Het is niet gelukt de stream op te halen: \n ${streamApiResponse.body}`, response.status);
        }
    }
    catch (error) {
        if (error instanceof Error) {
            if (error.message === 'AbortError') {
                npoplayer.doError('Het is niet gelukt de stream op te halen: \n Request timed out', 408);
            }
            else {
                npoplayer.doError(`Het is niet gelukt de stream op te halen: \n ${error.message}`, 500);
            }
        }
    }
}
